// Library Imports
import store from "store";
import { History } from "history";

// Local Imports
import {
  CREATE_SALESX_GROUP,
  SALESX_GROUP_NAME_UPDATE,
  SALESX_GROUP_DELETE,
  SALESX_GROUPS_LISTING,
  SALESX_GROUP_DETAIL,
  SALESX_USERS_LISTING,
} from "../../constants/types/groupTypes";
import {
  createGroupForExportWidgetsService,
  deleteGroupsService,
  exportWidgetUpdateStatusService,
  getGroupDetailsService,
  getUsersListForExportWidgetsService,
  updateGroupsService,
} from "modules/Services/SalesXGroupsService";
import { getSalesXGroupsListsService } from "modules/Services/SalesXGroupsService";
import { getQueryNewGroup } from "./utils";

// ACTIONS

// Update Group Name (through Edit Name)
export const updateGroupName = (groupName: string, groupId: number) => {
  const params = { groupName, groupId };
  store.dispatch({
    type: SALESX_GROUP_NAME_UPDATE.LOAD,
  });
  updateGroupsService(params)
    .then((res: any) => {
      if (res.data) {
        if (res.data["message"]) {
          store.dispatch({
            type: SALESX_GROUP_DETAIL.MESSAGE,
            payload: { message: res.data["message"] },
          });
        } else {
          store.dispatch({
            type: SALESX_GROUP_NAME_UPDATE.SUCCESS,
            payload: { groupName, groupId },
          });
        }
      } else {
        store.dispatch({
          type: SALESX_GROUP_NAME_UPDATE.FAIL,
        });
      }
    })
    .catch((err: any) => {
      console.log("update name err", err);
      store.dispatch({
        type: SALESX_GROUP_NAME_UPDATE.FAIL,
      });
    });
};

export const resetMessage = () => {
  store.dispatch({
    type: SALESX_GROUP_DETAIL.MESSAGE,
    payload: { message: "" },
  });
};

// Update Group (Add)
export const updateGroups = (
  groupId: string,
  addUsers?: number[],
  deleteUsers?: number[],
  personalityType?: string[],
  searchTerm?: string,
  saveAll?: boolean,
  deleteAll?: boolean
) => {
  //
  const params = { groupId, addUsers, deleteUsers, personalityType, searchTerm, saveAll, deleteAll };
  store.dispatch({
    type: SALESX_GROUP_DETAIL.LOAD,
  });
  updateGroupsService(params)
    .then((res: any) => {
      if (res.data.success) {
        console.log("Update Group: ", res.data);
        store.dispatch({
          type: SALESX_GROUP_DETAIL.UPDATE,
          payload: { addUsers, deleteUsers },
        });
      } else {
        store.dispatch({
          type: SALESX_GROUP_DETAIL.FAIL,
        });
      }
    })
    .catch((err: any) => {
      store.dispatch({
        type: SALESX_GROUP_DETAIL.FAIL,
      });
    });
};

export const removeUsersFromGroups = (
  gId: any,
  selectAll: any,
  selectedIds: any,
  idsExcept: any,
  searchTerm: any,
  personality: any
) => {
  store.dispatch({ type: SALESX_GROUP_DETAIL.DELETE_LOAD });
  return updateGroupsService({
    groupId: gId,
    deleteAll: selectAll || idsExcept.length > 0,
    exceptUsers: idsExcept,
    deleteUsers: selectedIds,
    searchTerm,
    personalityType: personality,
    saveFlag: false,
  })
    .then(() => {
      store.dispatch({
        type: SALESX_GROUP_DETAIL.DELETE_SUCCESS,
        payload: {
          groupId: gId,
          deleteAll: selectAll,
          exceptUsers: idsExcept,
          deleteUsers: selectedIds,
          selectedUsersTotalCount: selectedIds.length,
        },
      });
    })
    .catch(() => {
      store.dispatch({ type: SALESX_GROUP_DETAIL.DELETE_FAIL });
    });
};

export const addUsersInGroups = (
  gId: any,
  selectAll: any,
  selectedIds: any,
  idsExcept: any,
  searchTerm: any,
  personality: any
) => {
  store.dispatch({ type: SALESX_GROUP_DETAIL.ADD_LOAD });
  return updateGroupsService({
    groupId: gId,
    saveAll: selectAll || idsExcept.length > 0,
    exceptUsers: idsExcept,
    addUsers: selectedIds,
    searchTerm,
    personalityType: personality,
    saveFlag: true,
  })
    .then(() => {
      store.dispatch({ type: SALESX_GROUP_DETAIL.ADD_SUCCESS });
    })
    .catch(() => {
      store.dispatch({ type: SALESX_GROUP_DETAIL.ADD_FAIL });
    });
};

export const updateGroupCount = (gid: any, count: any) => {
  store.dispatch({
    type: SALESX_GROUPS_LISTING.UPDATE_GROUP_USERS_COUNT,
    payload: {
      gid,
      count,
    },
  });
};
// Global Users Listing
export const getSalesXGroupUsersAction = (params: any, placeInDetails: any = false) => {
  store.dispatch({ type: SALESX_USERS_LISTING.LOAD });
  return getUsersListForExportWidgetsService(params)
    .then(({ data }) => {
      console.log("Global Listing data: ", data);
      // if (placeInDetails) {
      //   store.dispatch({
      //     type: SALESX_GROUP_DETAIL.ADD_USERS,
      //     payload: { users: data.users, totalCount: data.totalCount },
      //   });
      // } else {
      store.dispatch({
        type: SALESX_USERS_LISTING.LOAD_SUCCESS,
        payload: { users: data.users, totalCount: data.totalCount },
      });
      // }
    })
    .catch((err) => {
      console.log("err : ", err);
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: SALESX_GROUPS_LISTING.FAIL,
        });
      }
    });
};

// Groups Listing
export const getSalesXGroupsAction = (params: any) => {
  store.dispatch({ type: SALESX_GROUPS_LISTING.LOAD });
  getSalesXGroupsListsService(params)
    .then(({ data }) => {
      store.dispatch({
        type: SALESX_GROUPS_LISTING.LOAD_SUCCESS,
        payload: { groups: data.groups, totalCount: data.totalCount },
      });
    })
    .catch((err) => {
      console.log("err : ", err);
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: SALESX_GROUPS_LISTING.FAIL,
        });
      }
    });
};

// Group's Users Listing
export const getSalesXGroupDetails = (params: any) => {
  const gId = params.groupId;
  store.dispatch({
    type: SALESX_GROUP_DETAIL.LOAD,
  });
  return getGroupDetailsService(params)
    .then((res: any) => {
      const data = res.data;
      console.log("Group Details data: ", data);
      store.dispatch({
        type: SALESX_GROUP_DETAIL.SUCCESS,
        payload: {
          id: gId,
          name: data.name,
          users: data.users_data.users,
          groupId: gId,
          totalCount: data.users_data.totalCount,
          isDeletable: data.isDeletable,
        },
      });
    })
    .catch((err) => {
      console.log("err : ", err);
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: SALESX_GROUP_DETAIL.FAIL,
        });
      }
    });
};

// Create Group
export const createGroupForExportWidgets = (groupName: string, history: History) => {
  console.log("Create Group Data history:", history);
  store.dispatch({ type: CREATE_SALESX_GROUP.LOAD });
  createGroupForExportWidgetsService(groupName)
    .then(({ data }) => {
      console.log("Cerate Group Response Data: ", data);
      store.dispatch({
        type: CREATE_SALESX_GROUP.SUCCESS,
        payload: { name: data.name, id: data.groupId },
      });
      if (window.location.search === "") {
        history.push(`/groups/group-list?group_id=${data.groupId}`);
      } else {
        //* this is handling of creating new group on Export Widget Popup
        let queryParams = new URLSearchParams(window.location.search);
        if (queryParams.has("group_id")) {
          queryParams.delete("group_id");
        }
        queryParams.append("group_id", data.groupId);
        if (!queryParams.has("exportPopup")) {
          queryParams.append("exportPopup", "true");
        }
        // if (queryParams.has("newGroup")) {
        //   queryParams.delete("group_id");
        // }
        queryParams.append("newGroup", "true");
        history.push(`/groups/group-list?${queryParams.toString()}`);
      }
    })
    .catch((err: any) => {
      store.dispatch({
        type: CREATE_SALESX_GROUP.FAIL,
      });
      console.log("Creation error 1");
    });
};

// Delete Group
export const deleteSalesXGroup = (groupId: number) => {
  store.dispatch({ type: SALESX_GROUP_DELETE.LOAD });
  return deleteGroupsService(groupId)
    .then(({ data }) => {
      store.dispatch({
        type: SALESX_GROUP_DELETE.SUCCESS,
        payload: groupId,
      });
    })
    .catch((err: any) => {
      store.dispatch({
        type: SALESX_GROUP_DELETE.FAIL,
      });
      console.log("Deletion error", err);
    });
};

export const removeExportedUsersGroupsFromRedux = (selectionObj: any) => {
  const {
    checkedUsers,
    selectAllUsersExcept,
    selectAllUsers,
    checkedGroups,
    selectAllGroupsExcept,
    selectAllGroups,
  } = selectionObj;

  store.dispatch({
    type: SALESX_USERS_LISTING.EXPORT_REMOVE,
    payload: {
      selectAllUsers,
      checkedUsers,
      selectAllUsersExcept,
    },
  });
  store.dispatch({
    type: SALESX_GROUPS_LISTING.EXPORT_REMOVE,
    payload: {
      selectAllGroups,
      checkedGroups,
      selectAllGroupsExcept,
    },
  });
};
//Submit Status
export const submitExportWidgetsStatus = (selectionObj: any) => {
  let params: any = {};
  const {
    searchTerm,
    campaignId,
    isExported,
    checkedUsers,
    selectAllUsersExcept,
    selectAllUsers,
    checkedGroups,
    selectAllGroupsExcept,
    selectAllGroups,
  } = selectionObj;
  params["searchTerm"] = searchTerm;
  params["campaignId"] = campaignId;

  if (isExported) {
    params["removeAllGroups"] = selectAllGroups;
    params["removeGroups"] = checkedGroups;
    params["exceptGroups"] = selectAllGroupsExcept;

    params["removeAllUsers"] = selectAllUsers;
    params["removeUsers"] = checkedUsers;
    params["exceptUsers"] = selectAllUsersExcept;
  } else {
    params["selectAllGroups"] = selectAllGroups;
    params["addGroups"] = checkedGroups;
    params["exceptGroups"] = selectAllGroupsExcept;

    params["selectAllUsers"] = selectAllUsers;
    params["addUsers"] = checkedUsers;
    params["exceptUsers"] = selectAllUsersExcept;
  }
  return exportWidgetUpdateStatusService(params);
};

export const resetSelectedGroup = () => {
  store.dispatch({
    type: SALESX_GROUP_DETAIL.RESET,
  });
};

export const resetWidgetsListing = () => {
  store.dispatch({
    type: SALESX_USERS_LISTING.RESET,
  });
  store.dispatch({
    type: SALESX_GROUPS_LISTING.RESET,
  });
};

export const resetWidgetsPopupData = () => {
  store.dispatch({
    type: SALESX_USERS_LISTING.RESET,
  });
  store.dispatch({
    type: SALESX_GROUPS_LISTING.RESET,
  });
  store.dispatch({
    type: SALESX_USERS_LISTING.RESET,
  });
};

export const resetGroups = () => {
  store.dispatch({
    type: SALESX_GROUPS_LISTING.RESET,
  });
};

export const resetUsers = () => {
  store.dispatch({
    type: SALESX_USERS_LISTING.RESET,
  });
};

export const resetSelectedGroupUsers = () => {
  store.dispatch({
    type: SALESX_GROUP_DETAIL.RESET_USERS,
  });
};
